<template class="student-registry">
  <div class="text-fix">
    <div class="col-12 d-flex mb-0 pb-0">
      <div class="col-8">
        <TitleBreadCrumb :page="page" />
      </div>
      <div
        v-if="registries.length > 0"
        class="col-4 d-flex align-self-end text-right"
      >
        <action-button
          id="btn-registry-evaluate"
          variant="success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-clipboard-check"
        >
          Evaluado
        </action-button>
        <action-button
          id="btn-registry-view"
          variant="outline-success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-clipboard-user"
          @click="goToAddRegistration()"
        >
          Registro
        </action-button>
        <action-button
          id="btn-registry-deactivate"
          variant="outline-danger m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-times-circle"
        >
          Inactivar
        </action-button>
      </div>
      <div
        v-if="registries.length == 0"
        class="col-4 align-self-end text-right"
      >
        <action-button
          id="btn-registry-add"
          variant="success m-2 pl-4 pr-4"
          type="submit"
          i="fas fa-file-plus"
          @click="goToAddRegistration()"
        >
          Añadir
        </action-button>
      </div>
    </div>
    <div class="dropdown-divider mt-0 pb-2 ml-3 w-100" />
    <div v-if="registries.length == 0" class="mt-4">
      <div class="col-12 d-flex mt-4 p-4">
        <div class="col-12 text-center align-items-center">
          <img
            src="@/assets/img/regular-unlink.svg"
            alt="regular-unlink"
            class="img-box text-center"
          />
        </div>
      </div>
      <div class="col-12 text-center  empty-registry-text">
        <span>
          Actualmente no existe ningún registro para este estudiante.
          <br />
        </span>
        <span>
          <b>Para crear un registro, favor de oprimir el botón de añadir.</b>
        </span>
      </div>
    </div>

    <div class="col-12 ">
      <div
        v-if="registries.length > 0"
        class="header d-flex justify-content-center p-3 "
      >
        Año Escolar 2006-2007
      </div>
    </div>
    <div class="col-12">
      <div
        v-for="registry in registries"
        :key="registry.id"
        class="col-12"
        :class="{
          'row-odd': registry.id % 2 === 0,
          'row-even': registry.id % 2 !== 0,
        }"
      >
        <div class="col-12 d-flex justify-content-between p-3">
          <div class="col-4">
            <span>
              <b>Número: {{ registry.number }}</b>
            </span>
          </div>
          <div
            class="col-2 mt-2 p-2 registry-status text-center "
            :class="registry.status.color"
          >
            <span>
              <b>{{ registry.status.name }}</b>
            </span>
          </div>
          <div class="col-4 pt-1 text-right">
            <div class="dropdown">
              <button
                :key="'btnRegistry-' + registry.number"
                class="btn btn-dropdown-actions dropdown-toggle pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                Acciones
              </button>
              <div class="dropdown-menu" aria-labelledby="ddAdiestramiento">
                <div
                  :id="'btnRegistryEdit-' + registry.number"
                  class="dropdown-item"
                >
                  <em class="fa fa-pencil text-green pr-1" />
                  <span>Editar</span>
                </div>
                <div
                  :id="'btnRegistryPrint-' + registry.number"
                  class="dropdown-item"
                >
                  <em class="fa fa-print text-green pr-1" />
                  <span>Imprimir</span>
                </div>
                <div
                  :id="'btnRegistryDelete-' + registry.number"
                  class="dropdown-item"
                >
                  <em class="fas fa-times-circle text-red pr-1" />
                  <span>Eliminar</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="dropdown-divider mt-0 pb-2 ml-3 w-100" />
        <div class="col-12">
          <section-title content="Información General" :has-line="false" />
        </div>
        <div class="col-12 d-flex  p-3">
          <div class="col-4 text-left">
            <span>
              <b>Año Académico:</b>
              <br />
            </span>
            <span>{{ generalInfo.academicYear }}</span>
          </div>
          <div class="col-4">
            <span>
              <b>Número:</b>
              <br />
            </span>
            <span>{{ generalInfo.number }}</span>
          </div>
        </div>
        <div class="col-12">
          <section-title content="Datos de Referido" :has-line="false" />
        </div>
        <div class="col-12 d-flex p-3">
          <div class="col-2">
            <span>
              <b>Tipo:</b>
              <br />
            </span>
            <span>{{ referealData.type }}</span>
          </div>
          <div class="col-2">
            <span>
              <b>Lugar:</b>
              <br />
            </span>
            <span>{{ referealData.place }}</span>
          </div>
          <div class="col-2">
            <span>
              <b>Región:</b>
              <br />
            </span>
            <span>{{ referealData.region }}</span>
          </div>
          <div class="col-2">
            <span>
              <b>Districto:</b>
              <br />
            </span>
            <span>{{ referealData.district }}</span>
          </div>
          <div class="col-4">
            <span>
              <b>Escuela:</b>
              <br />
            </span>
            <span>{{ referealData.school }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ActionButton } from '@/components/common';
import TitleBreadCrumb from '@/components/common/page/TitleBreadcrumb.vue';
import SectionTitle from '@/components/pei/shared/SectionTitle.vue';

export default {
  name: 'Registry',
  components: {
    ActionButton,
    TitleBreadCrumb,
    SectionTitle,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-clipboard-user',
        title: 'Registro del Estudiante',
        routes: ['Estudiante', 'Registro del Estudiante'],
      },
      registries: [
        /*
        {
          id: 0,
          number: "0000-151709",
          date: "01/oct./2012",
          status: { id: 0, name: "Servido", color: "state-green" }
        },
        {
          id: 1,
          number: "0000-151709",
          date: "01/oct./2012",
          status: { id: 1, name: "Pre-Registro", color: "state-yellow" }
        },
        {
          id: 2,
          number: "0000-151709",
          date: "01/oct./2012",
          status: { id: 2, name: "Registro", color: "state-green" }
        },
        {
          id: 3,
          number: "0000-151709",
          date: "01/oct./2012",
          status: { id: 3, name: "Evaluado", color: "state-green" },
        },
        {
          id: 4,
          number: "0000-151709",
          date: "01/oct./2012",
          status: { id: 4, name: "Elegible", color: "state-green" },
        },
        {
          id: 5,
          number: "0000-151709",
          date: "01/oct./2012",
          status:{ id: 5, name: "No Elegible", color: "state-red" },
        },
        {
          id: 6,
          number: "0000-151709",
          date: "01/oct./2012",
          status: { id: 6, name: "Inactivo", color: "state-yellow" }
        }*/
      ],
      generalInfo: {
        id: 0,
        academicYear: '2006-2007',
        number: '0000151709',
      },
      referealData: {
        id: 0,
        type: 'Problema Habla y Lenguaje',
        place: 'Hogar',
        region: 'Mayaguez',
        district: 'Cabo Rojo',
        school: '50120 - ELEMENTAL URBANA NUEVA',
      },
    };
  },

  methods: {
    goToAddRegistration() {
      this.$router.push({ path: '/student/registrations' });
    },
  },
};
</script>
<style scoped>
a i.fas.fa-exclamation-triangle {
  color: #ff5b5c;
}
a.active i.fas.fa-exclamation-triangle {
  color: white;
}
.header {
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #ffffff;
  opacity: 1;
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 5px 5px 0px 0px;
  opacity: 1;
}
.text-fix {
  font-weight: 400;
}

.registry-status {
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 26px;
  opacity: 1;
  width: 189px;
  height: 37px;
}

.state-green {
  background: #a3e5b3;
}

.state-yellow {
  background: #f8eb7f;
}
.state-red {
  background: #fcc9c8;
}
.row-odd {
  background-color: #fafbfa;
}

.row-even {
  background-color: #ffffff;
}

.btn-green {
  border: 1px solid #2db782;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.empty-registry-text {
  color: #727272;
}
</style>
